<template>
  <div class="TeamCard">
    <img :src="image" class="TeamCard__image">
    <h3 class="TeamCard__initials">{{ initial }}</h3>
    <p class="TeamCard__post">{{ post }}</p>
    <a :href="linkedIn" target="_blank" class="TeamCard__linkedin"><font-awesome-icon :icon="{ prefix: 'fab', iconName: 'linkedin' }"/></a>
  </div>
</template>
<script>
export default {
  name: 'TeamCard',
  props: {
    initial: {
      type: String,
      default: ''
    },
    post: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    linkedIn: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss">
.TeamCard {
  position: relative;
  width: 367px;
  height: 320px;
  background: #FFFFFF;
  border: 1px solid #F2F2F2;
  box-sizing: border-box;
  box-shadow: 0 15px 30px -10px rgba(21, 17, 71, 0.09);
  margin: 100px 9px 10px;
  border-radius: 24px;
  text-align: center;
  color: $color;
  padding-top: 155px;
  &__image {
    position: absolute;
    object-fit: cover;
    width: 220px;
    height: 220px;
    top: 10%;
    left: 50%;
    border: 1px solid #F2F2F2;
    box-sizing: border-box;
    box-shadow: 0px 27px 23px -10px rgba(21, 17, 71, 0.16);
    border-radius: 110px;
    transform: translate(-50%, -50%);
  }
  &__initials {
    font-weight: 600;
    font-size: 24px;
    line-height: 150%;
  }
  &__post {
    font-size: 18px;
    line-height: 150%;
    margin: 14px 0 30px;
  }
  &__linkedin {
    color: inherit;
    font-size: 25px;
  }
}
</style>
